"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef, createElement } from "react";
import { cardsRecipe } from "./cards.css.js";
import { LoadingSkeleton } from "./SharedComponents.js";
const ActionCard = forwardRef(function ActionCard2({ $as, as, children, isLoading, density, ...props }, ref) {
  const cardProps = {
    ref,
    ...props,
    className: classNames(cardsRecipe({
      type: "action",
      isLoading,
      density
    }), props.className)
  };
  return createElement($as ?? as ?? "button", cardProps, jsx(Fragment, { children: isLoading ? jsx(LoadingSkeleton, {}) : children }));
});
export {
  ActionCard
};
